"use client";

import SessionProvider from "../component/SessionProvider";
import { usePathname } from "next/navigation";
import { Provider } from "react-redux";
import { store } from "../lib/store";
import { StoreProvider } from "../context/StoreContext";
import FlowbiteScript from "../component/flowbitScript";
import GlobalStoreSelector from "../components/GlobalStoreSelector";
import Script from "next/script";

export default function ClientLayout({ children }) {
  const pathname = usePathname();
  const display_layout =
    pathname.includes("signin") || pathname.includes("signup");

  return (
    <>
      {/* Google tag (gtag.js) */}
      {/* <Script
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-EG1SGGE1BT"
      ></Script>
      <Script id="google-analytics">
        {`
          window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());

  gtag('config', 'G-EG1SGGE1BT');
        `}
      </Script> */}
      <Script id="gtm-init" strategy="afterInteractive">
        {`
   (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PD8KZX9W');
  `}
      </Script>

      {/* <!-- Google tag (gtag.js) --> */}
      <Script async src="https://www.googletagmanager.com/gtag/js?id=G-LNC3X1X8CW" strategy='afterInteractive' />
      <Script id='google-analytics-2' strategy='afterInteractive'>
        {`
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-LNC3X1X8CW');
  `}
      </Script>

      {/* <!-- Google Tag Manager --> */}
      {/* <Script id="google-tag-manager">
        {`(function(w,d,s,l,i){w[l] = w[l] || [];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-PZT98Q63');`}
      </Script> */}
      {/* <!-- End Google Tag Manager --> */}

      {/* Start Facebook SDK */}
      {/* <Script>
        window.fbAsyncInit = function() {
          FB.init({
            appId: '{your-app-id}',
            cookie: true,
            xfbml: true,
            version: '{api-version}'
          });

        FB.AppEvents.logPageView();   
    
  };

        (function(d, s, id){
   var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {return;}
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
 }(document, 'script', 'facebook-jssdk'));
      </Script> */}
      {/* End Facebook SDK */}

      <SessionProvider>
        <Provider store={store}>
          <StoreProvider>
            <GlobalStoreSelector />
            {children}
          </StoreProvider>
        </Provider>
      </SessionProvider>

      {/* <!-- Google Tag Manager (noscript) --> */}
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-PD8KZX9W"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript>
      {/* <!-- End Google Tag Manager (noscript) --> */}

      <FlowbiteScript />
      {/* <!-- Google Tag Manager (noscript) --> */}
      {/* <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-PZT98Q63"
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
        ></iframe>
      </noscript> */}
      {/* <!-- End Google Tag Manager (noscript) --> */}
    </>
  );
}

